export type SocialPlatformId = 'youtube' | 'instagram' | 'facebook';

export interface SocialMediaEntry {
  id: SocialPlatformId;
  label: string;
  /** When empty, the entry is shown as text only (no link). */
  url: string;
  username: string;
  iconClass: string;
  linkClass: string;
}

/** Centralized social links — set REACT_APP_*_URL when profile URLs are confirmed. */
export const SOCIAL_MEDIA_ENTRIES: readonly SocialMediaEntry[] = [
  {
    id: 'youtube',
    label: 'YouTube',
    url: process.env.REACT_APP_YOUTUBE_URL?.trim() || 'https://www.youtube.com/@sadecebilgisayar3865',
    username: '@sadecebilgisayar3865',
    iconClass: 'fab fa-youtube',
    linkClass: 'sb-footer-social__link--youtube',
  },
  {
    id: 'instagram',
    label: 'Instagram',
    url: process.env.REACT_APP_INSTAGRAM_URL?.trim() || '',
    username: '@sadecebilgisayar',
    iconClass: 'fab fa-instagram',
    linkClass: 'sb-footer-social__link--instagram',
  },
  {
    id: 'facebook',
    label: 'Facebook',
    url: process.env.REACT_APP_FACEBOOK_URL?.trim() || '',
    username: '@sadecebilgisayar',
    iconClass: 'fab fa-facebook-f',
    linkClass: 'sb-footer-social__link--facebook',
  },
];
